var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "icon-design-showcase position-relative",
      attrs: { id: "icon-pack-design-showcase" },
    },
    [
      _c(
        "svg",
        {
          class: [
            "icon-design",
            { "is-highlighting-grid": _vm.isHighlightingIconDesignGrid },
            { "is-highlighting-canvas": _vm.isHighlightingIconDesignCanvas },
          ],
          style: `
      --size: ${_vm.iconPack().sourceGridHeight};
      --padding: ${_vm.iconDesignPadding};
      --icon-design-specimen-primary-color: var(--theme-icon-design-path-color);
      --icon-design-specimen-secondary-color: var(--theme-icon-design-fill-color);
    `,
          attrs: {
            id: `icon-design-${_vm.iconPack().name}`,
            viewBox: `0 0 ${_vm.iconPackSourceCanvasHeight} ${_vm.iconPackSourceCanvasHeight}`,
          },
        },
        [
          _c("rect", { staticClass: "reticle" }),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                viewBox: `0 0 ${_vm.iconDesignSVGViewboxSize} ${_vm.iconDesignSVGViewboxSize}`,
              },
            },
            [
              _vm.iconPack().iconDesignShowcase.secondaryPath
                ? _c("path", {
                    staticStyle: {
                      fill: "var(--icon-design-specimen-secondary-color, currentColor)",
                      opacity:
                        "var(--icon-design-specimen-secondary-opacity, 0.5)",
                    },
                    attrs: {
                      d: _vm.iconPack().iconDesignShowcase.secondaryPath,
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("path", {
                staticStyle: {
                  fill: "var(--icon-design-specimen-primary-color, currentColor)",
                  opacity: "var(--icon-design-specimen-primary-opacity, 1)",
                },
                attrs: { d: _vm.iconPack().iconDesignShowcase.primaryPath },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }